import * as types from '../constants/ActionTypes';

export const setAutorizacionViaje = autorizacion => dispatch => {
  dispatch({
    type: types.SET_AUTORIZACION_VIAJE,
    payload: {
      autorizacion,
    },
  });
};
